module.exports = __webpack_public_path__ + "static/img/5.61fe5d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/5.png
// module id = QM9N
// module chunks = 12